export const SHECA_USER_OPENID = 'SHECA_USER_OPENID'
export const USER_TOKEN = 'USER_TOKEN'
export const AGENT_INFO_QUERY_KEY = 'AGENT_INFO_QUERY_KEY'
